import { setNavigationStep } from 'v3/data/store/contractCard/actions';
import { ContractNavigationEnum } from 'v3/data/store/contractCard/enum';
import { ContractingStateEnum } from 'v3/data/store/contracting/enums';

const getNavigationStep = (
  contractingState: ContractingStateEnum,
  hasDevice: boolean,
  preContractDowloadAvailable?: boolean,
  flagPreContract?: boolean,
): ContractNavigationEnum => {
  const preContractState = flagPreContract && preContractDowloadAvailable && !hasDevice;

  const stateToNavigationStepMap: Partial<Record<ContractingStateEnum, ContractNavigationEnum>> = {
    [ContractingStateEnum.WaitingTermsAcceptance]: ContractNavigationEnum.INITIAL,
    [ContractingStateEnum.ProcessingAntiFraud]: ContractNavigationEnum.DEVICE_DETAILS,
    [ContractingStateEnum.WaitingContractEffectiveness]: preContractState
      ? ContractNavigationEnum.PRE_CONTRACT
      : hasDevice
        ? ContractNavigationEnum.SIGN_CONTRACT
        : ContractNavigationEnum.DEVICE_DETAILS,
    [ContractingStateEnum.ContractingFinished]: ContractNavigationEnum.CONTRACT_COMPLETED,
  };

  return stateToNavigationStepMap[contractingState] ?? ContractNavigationEnum.INITIAL;
};

export const updateNavigationStepByContractingState = (
  contractingState: ContractingStateEnum,
  hasDevice: boolean,
  preContractDowloadAvailable?: boolean,
  flagPreContract?: boolean,
) => {
  const navigationStep = getNavigationStep(contractingState, hasDevice, preContractDowloadAvailable, flagPreContract);
  setNavigationStep(navigationStep);
};
